export const hideModalConnectionError = (store) => {
    store.setState({
        showConnectionError: false
    })
}

export const showModalConnectionError = (store) => {
    store.setState({
        showConnectionError: true
    })
}

export const toggleModalLegend = (store) => {
    const showModalLegend = !store.getState().showModalLegend
    store.setState({ showModalLegend })
}

export const showPermissionAlert = (store, show) => {
    store.setState({
        showBlockedPopup: show
    })
}
